import { awards, professor } from "../data";
import { ExternalLink, PageIntro } from "../components/Shell";
import { TimelineList } from "../components/Records";

export default function AboutPage() {
  return (
    <>
      <PageIntro
        label="Professor"
        title="최정혜"
        aside={
          <>
            {professor.title}
            <br />
            {professor.appointment}
          </>
        }
      />

      <section className="page-section shell">
        <div className="about-lead">
          <figure>
            <div className="about-portrait">
              <img
                src="/media/choi-jeonghye.jpg"
                alt="최정혜 교수 공식 프로필"
                width="472"
                height="591"
              />
            </div>
            <figcaption className="photo-credit">
              연세대학교 경영대학 공식 교수진 페이지 · 최종 공개 전 사용 승인 확인
            </figcaption>
          </figure>
          <div className="about-copy">
            <p className="section-label">Jeonghye Choi</p>
            <h2>Marketing, Yonsei School of Business</h2>
            <p>{professor.introduction}</p>
            <div className="professor-links">
              <ExternalLink href={professor.officialProfileUrl}>공식 교수 프로필</ExternalLink>
              <a className="external-link" href={`mailto:${professor.email}`}>
                {professor.email}
              </a>
            </div>
          </div>
          <dl className="profile-facts">
            <div className="profile-fact">
              <dt>Position</dt>
              <dd>{professor.title}</dd>
            </div>
            <div className="profile-fact">
              <dt>Education</dt>
              <dd>Ph.D., The Wharton School</dd>
            </div>
            <div className="profile-fact">
              <dt>Office</dt>
              <dd>경영관 537호</dd>
            </div>
            <div className="profile-fact">
              <dt>Telephone</dt>
              <dd>{professor.telephone}</dd>
            </div>
            <div className="profile-fact">
              <dt>Verified</dt>
              <dd>{professor.verifiedAt}</dd>
            </div>
          </dl>
        </div>
      </section>

      <section className="page-section is-white">
        <div className="shell two-column-record">
          <section className="record-group" aria-labelledby="career-heading">
            <p className="section-label">Appointments</p>
            <h2 id="career-heading">경력</h2>
            <TimelineList records={professor.career} />
          </section>
          <section className="record-group" aria-labelledby="education-heading">
            <p className="section-label">Education</p>
            <h2 id="education-heading">학력</h2>
            <TimelineList records={professor.education} />
          </section>
        </div>
      </section>

      <section className="page-section shell" aria-labelledby="recognition-heading">
        <div className="section-header">
          <div>
            <p className="section-label">Selected recognition</p>
            <h2 id="recognition-heading">주요 수상</h2>
          </div>
        </div>
        <TimelineList
          records={awards.filter((award) =>
            [
              "상전유통학술상 최우수학술상",
              "Marketing Science Institute Young Scholar",
              "Robert D. Buzzell MSI Best Paper Award",
              "연세학술상 사회과학 분야",
              "연세대학교 우수업적교수상 연구부문"
            ].includes(award.title)
          )}
          headingLevel={2}
        />
      </section>
    </>
  );
}
